import { render, staticRenderFns } from "./TicketDetailsSummary.vue?vue&type=template&id=d9205e70"
import script from "./TicketDetailsSummary.vue?vue&type=script&lang=js"
export * from "./TicketDetailsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports